class ProductGridItemFetch extends HTMLElement {
    constructor() {
        super()
        this.content = null
        this.handle = this.dataset.handle
        this.url = `${window.theme.routes.root_url}products/${this.handle}?section_id=api-product-grid-item`;
        this.id = this.getAttribute('data-clerk-product-id')
        this.renderContent()
    }

    async fetchContent(){
        const response = await fetch(this.url)
   
        const content = await response.text()
        const html = new DOMParser().parseFromString(content, 'text/html')
        this.content = html.querySelector('product-grid-item')   
        // Adding clerk attributes for tracking purposes
        this.content.querySelectorAll('a').forEach((anchor) => {
            anchor.setAttribute('data-clerk-product-id', this.id)
            anchor.setAttribute('data-clerk-click-tracking-added', true)
        })
    }

    async renderContent(){
        await this.fetchContent()
        if (this.content) {
            // Insert the fetched content into the current element
            this.innerHTML = this.content.outerHTML;

            // Dispatch a custom event to notify that content has been rendered
            const event = new CustomEvent('productsFetched', {
                bubbles: true,
                detail: { content: this.content }
            });
            this.dispatchEvent(event);

            this.rendered = true;
        } else {
            console.error('Product grid item content is missing');
        }
    }
    
}

customElements.define('product-grid-item-fetch', ProductGridItemFetch)